module.exports = __webpack_public_path__ + "static/media/comment-times.da50f112.svg";